import React, { Component } from "react";
import ReactTagInput from "@pathofdev/react-tag-input";

class TagsInput extends Component {
  render() {
    const { name, label, error, value, onChangeCallback, ...rest } = this.props;

    return (
      <div className="form-group">
        <label htmlFor={name}>{label}</label>
        <ReactTagInput
          {...rest}
          name={name}
          tags={value}
          onChange={(newTags) => {
            onChangeCallback(name, newTags);
          }}
          className="form-control"
        />
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    );
  }
}

export default TagsInput;
